import React from 'react';
import "./Station.css";

function Station({station, isActive, isPlaying}) {
	return (
		<div className="station-card-inner">
			<StationThumbnail station={station}/>
			<div className="station-card-content">
				<div className="station-card-header">
					<span className="station-name">{station.name}</span>
					<NowPlayingStatus isActive={isActive} isPlaying={isPlaying}/>
				</div>
				<p className="station-description">{station.description}</p>
			</div>
		</div>
	);
}

function NowPlayingStatus({isActive, isPlaying}) {
	if (isActive && isPlaying) {
		return (
			<span className="station-badge" aria-label="Now playing" title="Now playing">
		        <span className="station-badge-bar"/>
		        <span className="station-badge-bar"/>
		        <span className="station-badge-bar"/>
		        <span className="station-badge-bar"/>
	        </span>
		)
	}
}

export function StationThumbnail({station, context = "list"}) {
	return (
		<div className={context === "list" ? "station-thumb-wrapper" : "artwork-placeholder"}>
			{station.image ? (
				<img
					src={station.image}
					alt={station.name}
					className={context === "list" ? "station-thumb" : "artwork-image"}
				/>
			) : (
				<div
					className={(context === "list" ? "station-thumb-fallback" : "artwork-fallback-icons") + " material-symbols-outlined"}
					aria-hidden="true">headphones</div>
			)}
		</div>
	)
}

export default Station;